import { render, staticRenderFns } from "./SettingsBots.vue?vue&type=template&id=e0702dfc&scoped=true&"
import script from "./SettingsBots.vue?vue&type=script&lang=js&"
export * from "./SettingsBots.vue?vue&type=script&lang=js&"
import style0 from "./SettingsBots.vue?vue&type=style&index=0&id=e0702dfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0702dfc",
  null
  
)

export default component.exports